const initialState = {
  open: false,
  details: '',
  cancelReasonTypeId: 0,
  reasonTypes: [],
};
export default initialState;
